/**
 * The `$`-glyph cost scale, shared by the on-page `DollarRating` component and the
 * provider social card (VIT-18194).
 *
 * Extracted so the two cannot disagree: a card that showed `$$` where the page it
 * links to shows `$$$$` would be a cost claim contradicting itself across a share
 * preview, which is worse than either value being wrong on its own.
 */

export const MAX_DOLLARS = 5

/**
 * How many of the `MAX_DOLLARS` glyphs are filled for a Ribbon `efficiencyIndex`.
 *
 * `efficiencyIndex` is 1 (least efficient / most expensive) … 5 (most efficient /
 * cheapest), so it is rendered INVERTED: `$$$$$` universally reads as expensive, and
 * the most cost-efficient provider therefore shows the fewest `$`. 5 → `$`, 1 → `$$$$$`.
 *
 * Clamped and rounded because the index arrives from an upstream API — a fractional
 * or out-of-range value must still land on a drawable number of glyphs.
 */
export const filledDollarCount = (efficiencyIndex: number): number =>
  MAX_DOLLARS + 1 - Math.min(MAX_DOLLARS, Math.max(1, Math.round(efficiencyIndex)))
